import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/styles';
import CardHeader from '@material-ui/core/CardHeader';

interface CardHeaderProps {
    className?: string,
    avatar: ReactNode,
    action?: ReactNode | null,
    subheader: ReactNode

}
const CommentCardHeader = function ({ className, avatar, action, subheader }: CardHeaderProps) {
    const useStyles = makeStyles(() => ({
        root: {
            paddingBottom: 0,
            paddingLeft: 13,
            paddingTop: 13,
            '& .MuiCardHeader-avatar': {
                marginRight: 14,
            },
            '& .MuiCardHeader-action': {
                marginRight: 0,
            },
        }
    }));

    const classes = useStyles().root;

    return (
        <CardHeader
            className={`${classes} ${className}`}
            avatar={avatar}
            action={action}
            subheader={subheader}
        />
    );
};

export default CommentCardHeader;